export default class UsersPrivilegeTreasuries {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.treasuriesAdd = false;
    this.treasuriesArchive = false;
    this.treasuriesDelete = false;
    this.treasuriesRestore = false;
    this.treasuriesUpdate = false;
    this.treasuriesView = false;
  }
  fillData(data) {
    this.treasuriesAdd = data.treasuriesAdd;
    this.treasuriesArchive = data.treasuriesArchive;
    this.treasuriesDelete = data.treasuriesDelete;
    this.treasuriesRestore = data.treasuriesRestore;
    this.treasuriesUpdate = data.treasuriesUpdate;
    this.treasuriesView = data.treasuriesView;
  }
}
